import { create } from 'zustand';

const LS_KEY = 'nexus_ui_prefs_v1';

export interface UiPreferenceState {
  darkMode: boolean;
  autoSave: boolean;
  showCompletedTasks: boolean;
  setDarkMode: (v: boolean) => void;
  setAutoSave: (v: boolean) => void;
  setShowCompletedTasks: (v: boolean) => void;
  hydrateFromLocal: () => void;
  persistLocal: () => void;
}

function readLs(): Partial<Pick<UiPreferenceState, 'darkMode' | 'autoSave' | 'showCompletedTasks'>> {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as Partial<Pick<UiPreferenceState, 'darkMode' | 'autoSave' | 'showCompletedTasks'>>;
  } catch {
    return {};
  }
}

export const useUiPreferenceStore = create<UiPreferenceState>()((set, get) => ({
  darkMode: false,
  autoSave: true,
  showCompletedTasks: true,

  setDarkMode: (v) => {
    set({ darkMode: v });
    get().persistLocal();
  },
  setAutoSave: (v) => {
    set({ autoSave: v });
    get().persistLocal();
  },
  setShowCompletedTasks: (v) => {
    set({ showCompletedTasks: v });
    get().persistLocal();
  },

  hydrateFromLocal: () => {
    const p = readLs();
    set({
      darkMode: typeof p.darkMode === 'boolean' ? p.darkMode : get().darkMode,
      autoSave: typeof p.autoSave === 'boolean' ? p.autoSave : get().autoSave,
      showCompletedTasks: typeof p.showCompletedTasks === 'boolean' ? p.showCompletedTasks : get().showCompletedTasks,
    });
  },

  persistLocal: () => {
    const { darkMode, autoSave, showCompletedTasks } = get();
    localStorage.setItem(LS_KEY, JSON.stringify({ darkMode, autoSave, showCompletedTasks }));
  },
}));
